module.exports = __webpack_public_path__ + "static/manabusakai-5d88b267ce72d9e5c87b484a59dfb1c9.jpg";